





















































import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import { each, isInteger } from 'lodash'
import { camelizeKeys } from '@/utils'

import Process from '@/components/workflow/Process.vue'
import Task from '@/components/workflow/Task'
import Timer from '@/components/workflow/Timer'
import Gateway from '@/components/workflow/Gateway'
import Measures from '@/survey/Measures.vue'
import Steps from '@/survey/elements/Steps.vue'
import { kebabToCamelCase } from '@/utils'
import AssessmentMixin from './AssessmentMixin'

export default mixins(AssessmentMixin).extend({
  components: {
    Evaluation: require('@/survey/measures/evaluation/Evaluation.vue').default,
    CommonPost: require('./CommonPost.vue').default,
    Gateway,
    Measures,
    Process,
    Steps,
    Task,
    Timer,
    Sewip: require('@/survey/measures/sewip/SewipPatients.vue').default,
    Wai: require('@/survey/measures/wai/Wai.vue').default,
  },
  data() {
    return {
      questions: {
        comment: kebabToCamelCase(require('@/survey/measures/evaluation/comment.yml')),
      },
    }
  },
})
